import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav style={navStyle}>
      <div style={container}>

        {/* 🔥 LOGO (IMAGE + TEXT) */}
        <Link to="/" style={logoWrap}>
          <img
            src="/new-logo.png" // 👈 place file in public/logo.png
            alt="PRG Cars"
            style={logoImg}
          />

          <span style={logoText}>
            PRG <span style={{ color: '#FFD700' }}>CARS</span>
          </span>
        </Link>

        {/* DESKTOP MENU */}
        {isDesktop && (
          <div style={menu}>
            <Link to="/#" style={link}>Inventory</Link>
            <Link to="/sellcar" style={link}>Sell Car</Link>
            <Link to="/glossgarage" style={link}>Gloss Garage</Link>
            <Link to="/aboutus" style={link}>About</Link>
          </div>
        )}

        {/* RIGHT SIDE */}
        <div style={right}>
          <a href="https://wa.me/919766624663" target="_blank" style={cta}>
            Contact
          </a>

          {!isDesktop && (
            <button
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              style={menuBtn}
            >
              {isMobileOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          )}
        </div>
      </div>

      {/* MOBILE MENU */}
      {!isDesktop && isMobileOpen && (
        <div style={mobileMenu}>
          <Link to="/" onClick={() => setIsMobileOpen(false)} style={mobileLink}>Inventory</Link>
          <Link to="/sellcar" onClick={()=>setIsMobileOpen(false) }style={mobileLink}>Sell Your Car</Link>
          <Link to="/glossgarage" onClick={() => setIsMobileOpen(false)} style={mobileLink}>Gloss Garage</Link>
          <Link to="/aboutus" onClick={() => setIsMobileOpen(false)} style={mobileLink}>About</Link>
          <a
            href="https://wa.me/919766624663"
            target="_blank"
            onClick={() => setIsMobileOpen(false)}
            style={mobileLink}
          >
            Contact
          </a>
        </div>
      )}
    </nav>
  );
}

/* ---------- STYLES ---------- */

const navStyle = {
  position: 'sticky' as const,
  top: 0,
  zIndex: 100,
  background: '#0d0d0d',
  borderBottom: '1px solid #222',
};

const container = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '12px 16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

/* 🔥 LOGO */
const logoWrap = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  textDecoration: 'none',
};

const logoImg = {
  width: '2.5rem',
  objectFit: 'contain' as const,
  borderRadius: '6px',
};

const logoText = {
  fontSize: '18px',
  fontWeight: 700,
  color: '#fff',
};

/* MENU */
const menu = {
  display: 'flex',
  gap: '22px',
};

const link = {
  color: '#ccc',
  textDecoration: 'none',
  fontSize: '14px',
  transition: '0.2s',
};

/* RIGHT SIDE */
const right = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

const cta = {
  padding: '8px 14px',
  borderRadius: '8px',
  background: '#FFD700',
  color: '#000',
  fontSize: '13px',
  textDecoration: 'none',
  fontWeight: 600,
};

/* MOBILE */
const menuBtn = {
  background: 'transparent',
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
};

const mobileMenu = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '14px',
  padding: '16px',
  background: '#111',
  borderTop: '1px solid #222',
};

const mobileLink = {
  color: '#fff',
  textDecoration: 'none',
  fontSize: '14px',
};